// Auth configuration types
export interface AuthConfig {
  // Authentik OAuth2 configuration
  authentikClientId?: string
  authentikAuthorizationEndpoint?: string
  authentikTokenEndpoint?: string
  authentikUserInfoEndpoint?: string
  authentikLogoutEndpoint?: string
  authentikScope?: string
  cookie: {
    name: string
    expirationDays: number
  }
  googleClientId?: string
  allowedDomain: string
}

// User type
export interface User {
  id: string
  name: string
  email: string
  // Optional fields
  avatar?: string
  provider?: 'google' | 'authentik'
  email_verified?: boolean
  groups?: string[]
}

// Authentik-specific user type
export interface AuthentikUser extends User {
  provider: 'authentik'
  accessToken?: string
  refreshToken?: string
  idToken?: string
}

// Authentik Auth Error class
export class AuthentikAuthError extends Error {
  constructor(
    message: string,
    public originalError?: unknown
  ) {
    super(message)
    this.name = 'AuthentikAuthError'
  }
}

export interface AuthState {
  isAuthenticated: boolean
  user: User | null
  loading: boolean
  error: Error | null
}
